import React from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import GetCommissionResponse from '../../../Api/CRM/Responses/CommissionResponse';
import ModifyParameterModal from '../../elements/ModifyParameterModal';
import Card from '../../elements/common/Card';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import useAutoPaginator from '../../hooks/useAutoPaginator';
import { ROLES } from '../../services/AdminPolicyService';

function ResellerCommissionsList({ id }: { id: number }) {
    const { items: commissions, updateItems, isLoading, auto } = useAutoPaginator<GetCommissionResponse>((page) =>
        CRMApi.resellers.getAllCommissions(id, page)
    );

    const handleAction = (lotteryId: number, value: number) =>
        CRMApi.resellers.updateCommission(id, lotteryId, value).then(() => updateItems());

    return (
        <Card title="All reseller commissions per lottery">
            <TableLoader isLoading={isLoading}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Lottery name</th>
                            <th>Reseller commission</th>
                            <th aria-label="Change buttons" />
                        </tr>
                    </thead>
                    <tbody>
                        {commissions.map((commission) => (
                            <tr key={commission.lottery_id}>
                                <td>{commission.lottery_name}</td>
                                <td>{commission.commission}</td>
                                <td>
                                    <ModifyParameterModal
                                        parameterName="commission"
                                        value={commission.commission}
                                        action={(value) => handleAction(commission.lottery_id, parseInt(value))}
                                        displayName="commission"
                                        roles={ROLES.MAIN_ADMINS}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

export default ResellerCommissionsList;
